import {AlarmActionsHeader} from "../utils/alarms-actions-ui.jsx";

const Header = ({header}) =>
  <th className="border border-[#e7e7e7] border-collapse text-[#4f4f4f]! bg-[#fafafa]">{header}</th>

const Data = ({data}) =>
  <td className="border border-[#e7e7e7] border-collapse">{data ?? ""}</td>
const HorizontalTableCard = ({name, items = [], className}) => {
  return(
    <div className={["w-full", className].join(" ")}>
      <AlarmActionsHeader header={name}/>
      <div className="border border-[#505050] p-2">
        <table className="text-[14px]">
          <thead>
            <tr>
              {items.map((el, idx) => <Header key={idx} header={el.label}/>)}
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              {items.map((el, idx) => <Data key={idx} data={el.value}/>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default HorizontalTableCard;